
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("lovXw"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("FPFpb"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("icWJI"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("8Lrt2"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("dzlyB"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("vy1ng"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("aJ7Ae"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("9E6gF"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("fgLed"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("jqQCa"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("eJ3ji"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("4293o"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("lovXw", function(module, exports) {

let $f934a13df88c474a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f934a13df88c474a$var$load("2YffH"),
    $f934a13df88c474a$var$load("1o23t"),
    $f934a13df88c474a$var$load("lqFMg"),
    $f934a13df88c474a$var$load("duC9l"),
    $f934a13df88c474a$var$load("ci4aH"),
    $f934a13df88c474a$var$load("l1nJ9"),
    $f934a13df88c474a$var$load("iQ0Jm"),
    $f934a13df88c474a$var$load("eBRUf"),
    $f934a13df88c474a$var$load("9Vh0G"),
    $f934a13df88c474a$var$load("hBIgN"),
    $f934a13df88c474a$var$load("h4Nf7"),
    $f934a13df88c474a$var$load("7f9Fz"),
    $f934a13df88c474a$var$load("8YSo7"),
    $f934a13df88c474a$var$load("e7ZUf"),
    $f934a13df88c474a$var$load("gL8bn"),
    $f934a13df88c474a$var$load("g9CVe"),
    $f934a13df88c474a$var$load("djHM5"),
    $f934a13df88c474a$var$load("eJQji"),
    $f934a13df88c474a$var$load("6wr18"),
    $f934a13df88c474a$var$load("kjZZD"),
    $f934a13df88c474a$var$load("3JSgG"),
    $f934a13df88c474a$var$load("dRpV3"),
    $f934a13df88c474a$var$load("ffEVr"),
    $f934a13df88c474a$var$load("dTsOE"),
    $f934a13df88c474a$var$load("jYUNl"),
    $f934a13df88c474a$var$load("foy8I"),
    $f934a13df88c474a$var$load("jY21r"),
    $f934a13df88c474a$var$load("2vAWg"),
    $f934a13df88c474a$var$load("7cABH"),
    $f934a13df88c474a$var$load("9jjvO"),
    $f934a13df88c474a$var$load("i8eeg"),
    $f934a13df88c474a$var$load("iFdoJ"),
    $f934a13df88c474a$var$load("2uVTT"),
    $f934a13df88c474a$var$load("hhss7"),
    $f934a13df88c474a$var$load("Wowvf"),
    $f934a13df88c474a$var$load("4Nzvy"),
    $f934a13df88c474a$var$load("hJpvQ"),
    $f934a13df88c474a$var$load("bIPPg"),
    $f934a13df88c474a$var$load("lnKog"),
    $f934a13df88c474a$var$load("h3ABO"),
    $f934a13df88c474a$var$load("kC80R"),
    $f934a13df88c474a$var$load("7EorR"),
    $f934a13df88c474a$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("FPFpb", function(module, exports) {

let $07dbe867bf856f90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $07dbe867bf856f90$var$load("2YffH"),
    $07dbe867bf856f90$var$load("1o23t"),
    $07dbe867bf856f90$var$load("lqFMg"),
    $07dbe867bf856f90$var$load("duC9l"),
    $07dbe867bf856f90$var$load("ci4aH"),
    $07dbe867bf856f90$var$load("l1nJ9"),
    $07dbe867bf856f90$var$load("iQ0Jm"),
    $07dbe867bf856f90$var$load("eBRUf"),
    $07dbe867bf856f90$var$load("9Vh0G"),
    $07dbe867bf856f90$var$load("hBIgN"),
    $07dbe867bf856f90$var$load("h4Nf7"),
    $07dbe867bf856f90$var$load("7f9Fz"),
    $07dbe867bf856f90$var$load("8YSo7"),
    $07dbe867bf856f90$var$load("e7ZUf"),
    $07dbe867bf856f90$var$load("gL8bn"),
    $07dbe867bf856f90$var$load("g9CVe"),
    $07dbe867bf856f90$var$load("djHM5"),
    $07dbe867bf856f90$var$load("eJQji"),
    $07dbe867bf856f90$var$load("6wr18"),
    $07dbe867bf856f90$var$load("kjZZD"),
    $07dbe867bf856f90$var$load("3JSgG"),
    $07dbe867bf856f90$var$load("dRpV3"),
    $07dbe867bf856f90$var$load("ffEVr"),
    $07dbe867bf856f90$var$load("dTsOE"),
    $07dbe867bf856f90$var$load("jYUNl"),
    $07dbe867bf856f90$var$load("foy8I"),
    $07dbe867bf856f90$var$load("jY21r"),
    $07dbe867bf856f90$var$load("2vAWg"),
    $07dbe867bf856f90$var$load("7cABH"),
    $07dbe867bf856f90$var$load("9jjvO"),
    $07dbe867bf856f90$var$load("i8eeg"),
    $07dbe867bf856f90$var$load("iFdoJ"),
    $07dbe867bf856f90$var$load("2uVTT"),
    $07dbe867bf856f90$var$load("hhss7"),
    $07dbe867bf856f90$var$load("Wowvf"),
    $07dbe867bf856f90$var$load("4Nzvy"),
    $07dbe867bf856f90$var$load("hJpvQ"),
    $07dbe867bf856f90$var$load("bIPPg"),
    $07dbe867bf856f90$var$load("lnKog"),
    $07dbe867bf856f90$var$load("h3ABO"),
    $07dbe867bf856f90$var$load("kC80R"),
    $07dbe867bf856f90$var$load("7EorR"),
    $07dbe867bf856f90$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("icWJI", function(module, exports) {

let $d416e8c9987d45e4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d416e8c9987d45e4$var$load("2YffH"),
    $d416e8c9987d45e4$var$load("1o23t"),
    $d416e8c9987d45e4$var$load("lqFMg"),
    $d416e8c9987d45e4$var$load("duC9l"),
    $d416e8c9987d45e4$var$load("ci4aH"),
    $d416e8c9987d45e4$var$load("l1nJ9"),
    $d416e8c9987d45e4$var$load("iQ0Jm"),
    $d416e8c9987d45e4$var$load("eBRUf"),
    $d416e8c9987d45e4$var$load("9Vh0G"),
    $d416e8c9987d45e4$var$load("hBIgN"),
    $d416e8c9987d45e4$var$load("h4Nf7"),
    $d416e8c9987d45e4$var$load("7f9Fz"),
    $d416e8c9987d45e4$var$load("8YSo7"),
    $d416e8c9987d45e4$var$load("e7ZUf"),
    $d416e8c9987d45e4$var$load("gL8bn"),
    $d416e8c9987d45e4$var$load("g9CVe"),
    $d416e8c9987d45e4$var$load("djHM5"),
    $d416e8c9987d45e4$var$load("eJQji"),
    $d416e8c9987d45e4$var$load("6wr18"),
    $d416e8c9987d45e4$var$load("kjZZD"),
    $d416e8c9987d45e4$var$load("3JSgG"),
    $d416e8c9987d45e4$var$load("dRpV3"),
    $d416e8c9987d45e4$var$load("ffEVr"),
    $d416e8c9987d45e4$var$load("dTsOE"),
    $d416e8c9987d45e4$var$load("jYUNl"),
    $d416e8c9987d45e4$var$load("foy8I"),
    $d416e8c9987d45e4$var$load("jY21r"),
    $d416e8c9987d45e4$var$load("2vAWg"),
    $d416e8c9987d45e4$var$load("7cABH"),
    $d416e8c9987d45e4$var$load("9jjvO"),
    $d416e8c9987d45e4$var$load("i8eeg"),
    $d416e8c9987d45e4$var$load("iFdoJ"),
    $d416e8c9987d45e4$var$load("2uVTT"),
    $d416e8c9987d45e4$var$load("hhss7"),
    $d416e8c9987d45e4$var$load("Wowvf"),
    $d416e8c9987d45e4$var$load("4Nzvy"),
    $d416e8c9987d45e4$var$load("hJpvQ"),
    $d416e8c9987d45e4$var$load("bIPPg"),
    $d416e8c9987d45e4$var$load("lnKog"),
    $d416e8c9987d45e4$var$load("h3ABO"),
    $d416e8c9987d45e4$var$load("kC80R"),
    $d416e8c9987d45e4$var$load("7EorR"),
    $d416e8c9987d45e4$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("8Lrt2", function(module, exports) {

let $661804f93dfeb105$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $661804f93dfeb105$var$load("e7ZUf"),
    $661804f93dfeb105$var$load("gL8bn"),
    $661804f93dfeb105$var$load("2YffH"),
    $661804f93dfeb105$var$load("lqFMg"),
    $661804f93dfeb105$var$load("duC9l"),
    $661804f93dfeb105$var$load("ci4aH"),
    $661804f93dfeb105$var$load("hJpvQ"),
    $661804f93dfeb105$var$load("l1nJ9"),
    $661804f93dfeb105$var$load("eBRUf"),
    $661804f93dfeb105$var$load("9Vh0G"),
    $661804f93dfeb105$var$load("hBIgN"),
    $661804f93dfeb105$var$load("h4Nf7"),
    $661804f93dfeb105$var$load("7f9Fz"),
    $661804f93dfeb105$var$load("8YSo7"),
    $661804f93dfeb105$var$load("g9CVe"),
    $661804f93dfeb105$var$load("djHM5"),
    $661804f93dfeb105$var$load("eJQji"),
    $661804f93dfeb105$var$load("6wr18"),
    $661804f93dfeb105$var$load("kjZZD"),
    $661804f93dfeb105$var$load("3JSgG"),
    $661804f93dfeb105$var$load("dRpV3"),
    $661804f93dfeb105$var$load("ffEVr"),
    $661804f93dfeb105$var$load("dTsOE"),
    $661804f93dfeb105$var$load("jYUNl"),
    $661804f93dfeb105$var$load("foy8I"),
    $661804f93dfeb105$var$load("jY21r"),
    $661804f93dfeb105$var$load("2vAWg"),
    $661804f93dfeb105$var$load("7cABH"),
    $661804f93dfeb105$var$load("9jjvO"),
    $661804f93dfeb105$var$load("i8eeg"),
    $661804f93dfeb105$var$load("iFdoJ"),
    $661804f93dfeb105$var$load("bIPPg"),
    $661804f93dfeb105$var$load("2uVTT"),
    $661804f93dfeb105$var$load("hhss7"),
    $661804f93dfeb105$var$load("Wowvf"),
    $661804f93dfeb105$var$load("4Nzvy"),
    $661804f93dfeb105$var$load("h3ABO"),
    $661804f93dfeb105$var$load("kC80R"),
    $661804f93dfeb105$var$load("7EorR"),
    $661804f93dfeb105$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("dzlyB", function(module, exports) {

let $9e0f440a25765047$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9e0f440a25765047$var$load("e7ZUf"),
    $9e0f440a25765047$var$load("gL8bn"),
    $9e0f440a25765047$var$load("2YffH"),
    $9e0f440a25765047$var$load("lqFMg"),
    $9e0f440a25765047$var$load("duC9l"),
    $9e0f440a25765047$var$load("ci4aH"),
    $9e0f440a25765047$var$load("hJpvQ"),
    $9e0f440a25765047$var$load("l1nJ9"),
    $9e0f440a25765047$var$load("eBRUf"),
    $9e0f440a25765047$var$load("9Vh0G"),
    $9e0f440a25765047$var$load("hBIgN"),
    $9e0f440a25765047$var$load("h4Nf7"),
    $9e0f440a25765047$var$load("7f9Fz"),
    $9e0f440a25765047$var$load("8YSo7"),
    $9e0f440a25765047$var$load("g9CVe"),
    $9e0f440a25765047$var$load("djHM5"),
    $9e0f440a25765047$var$load("eJQji"),
    $9e0f440a25765047$var$load("6wr18"),
    $9e0f440a25765047$var$load("kjZZD"),
    $9e0f440a25765047$var$load("3JSgG"),
    $9e0f440a25765047$var$load("dRpV3"),
    $9e0f440a25765047$var$load("ffEVr"),
    $9e0f440a25765047$var$load("dTsOE"),
    $9e0f440a25765047$var$load("jYUNl"),
    $9e0f440a25765047$var$load("foy8I"),
    $9e0f440a25765047$var$load("jY21r"),
    $9e0f440a25765047$var$load("2vAWg"),
    $9e0f440a25765047$var$load("7cABH"),
    $9e0f440a25765047$var$load("9jjvO"),
    $9e0f440a25765047$var$load("i8eeg"),
    $9e0f440a25765047$var$load("iFdoJ"),
    $9e0f440a25765047$var$load("bIPPg"),
    $9e0f440a25765047$var$load("2uVTT"),
    $9e0f440a25765047$var$load("hhss7"),
    $9e0f440a25765047$var$load("Wowvf"),
    $9e0f440a25765047$var$load("4Nzvy"),
    $9e0f440a25765047$var$load("h3ABO"),
    $9e0f440a25765047$var$load("kC80R"),
    $9e0f440a25765047$var$load("7EorR"),
    $9e0f440a25765047$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("vy1ng", function(module, exports) {

let $05ed494272248e41$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05ed494272248e41$var$load("e7ZUf"),
    $05ed494272248e41$var$load("gL8bn"),
    $05ed494272248e41$var$load("2YffH"),
    $05ed494272248e41$var$load("lqFMg"),
    $05ed494272248e41$var$load("duC9l"),
    $05ed494272248e41$var$load("ci4aH"),
    $05ed494272248e41$var$load("hJpvQ"),
    $05ed494272248e41$var$load("l1nJ9"),
    $05ed494272248e41$var$load("eBRUf"),
    $05ed494272248e41$var$load("9Vh0G"),
    $05ed494272248e41$var$load("hBIgN"),
    $05ed494272248e41$var$load("h4Nf7"),
    $05ed494272248e41$var$load("7f9Fz"),
    $05ed494272248e41$var$load("8YSo7"),
    $05ed494272248e41$var$load("g9CVe"),
    $05ed494272248e41$var$load("djHM5"),
    $05ed494272248e41$var$load("eJQji"),
    $05ed494272248e41$var$load("6wr18"),
    $05ed494272248e41$var$load("kjZZD"),
    $05ed494272248e41$var$load("3JSgG"),
    $05ed494272248e41$var$load("dRpV3"),
    $05ed494272248e41$var$load("ffEVr"),
    $05ed494272248e41$var$load("dTsOE"),
    $05ed494272248e41$var$load("jYUNl"),
    $05ed494272248e41$var$load("foy8I"),
    $05ed494272248e41$var$load("jY21r"),
    $05ed494272248e41$var$load("2vAWg"),
    $05ed494272248e41$var$load("7cABH"),
    $05ed494272248e41$var$load("9jjvO"),
    $05ed494272248e41$var$load("i8eeg"),
    $05ed494272248e41$var$load("iFdoJ"),
    $05ed494272248e41$var$load("bIPPg"),
    $05ed494272248e41$var$load("2uVTT"),
    $05ed494272248e41$var$load("hhss7"),
    $05ed494272248e41$var$load("Wowvf"),
    $05ed494272248e41$var$load("4Nzvy"),
    $05ed494272248e41$var$load("h3ABO"),
    $05ed494272248e41$var$load("kC80R"),
    $05ed494272248e41$var$load("7EorR"),
    $05ed494272248e41$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("aJ7Ae", function(module, exports) {

let $7cf3fd41b4f9e98f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7cf3fd41b4f9e98f$var$load("e7ZUf"),
    $7cf3fd41b4f9e98f$var$load("gL8bn"),
    $7cf3fd41b4f9e98f$var$load("2YffH"),
    $7cf3fd41b4f9e98f$var$load("lqFMg"),
    $7cf3fd41b4f9e98f$var$load("duC9l"),
    $7cf3fd41b4f9e98f$var$load("ci4aH"),
    $7cf3fd41b4f9e98f$var$load("l1nJ9"),
    $7cf3fd41b4f9e98f$var$load("eBRUf"),
    $7cf3fd41b4f9e98f$var$load("9Vh0G"),
    $7cf3fd41b4f9e98f$var$load("hBIgN"),
    $7cf3fd41b4f9e98f$var$load("h4Nf7"),
    $7cf3fd41b4f9e98f$var$load("7f9Fz"),
    $7cf3fd41b4f9e98f$var$load("8YSo7"),
    $7cf3fd41b4f9e98f$var$load("g9CVe"),
    $7cf3fd41b4f9e98f$var$load("djHM5"),
    $7cf3fd41b4f9e98f$var$load("eJQji"),
    $7cf3fd41b4f9e98f$var$load("6wr18"),
    $7cf3fd41b4f9e98f$var$load("kjZZD"),
    $7cf3fd41b4f9e98f$var$load("3JSgG"),
    $7cf3fd41b4f9e98f$var$load("dRpV3"),
    $7cf3fd41b4f9e98f$var$load("ffEVr"),
    $7cf3fd41b4f9e98f$var$load("dTsOE"),
    $7cf3fd41b4f9e98f$var$load("jYUNl"),
    $7cf3fd41b4f9e98f$var$load("foy8I"),
    $7cf3fd41b4f9e98f$var$load("jY21r"),
    $7cf3fd41b4f9e98f$var$load("2vAWg"),
    $7cf3fd41b4f9e98f$var$load("7cABH"),
    $7cf3fd41b4f9e98f$var$load("9jjvO"),
    $7cf3fd41b4f9e98f$var$load("i8eeg"),
    $7cf3fd41b4f9e98f$var$load("iFdoJ"),
    $7cf3fd41b4f9e98f$var$load("2uVTT"),
    $7cf3fd41b4f9e98f$var$load("hhss7"),
    $7cf3fd41b4f9e98f$var$load("Wowvf"),
    $7cf3fd41b4f9e98f$var$load("4Nzvy"),
    $7cf3fd41b4f9e98f$var$load("hJpvQ"),
    $7cf3fd41b4f9e98f$var$load("bIPPg"),
    $7cf3fd41b4f9e98f$var$load("lnKog"),
    $7cf3fd41b4f9e98f$var$load("h3ABO"),
    $7cf3fd41b4f9e98f$var$load("kC80R"),
    $7cf3fd41b4f9e98f$var$load("7EorR"),
    $7cf3fd41b4f9e98f$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("9E6gF", function(module, exports) {

let $705cb62515da7707$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $705cb62515da7707$var$load("2YffH"),
    $705cb62515da7707$var$load("lqFMg"),
    $705cb62515da7707$var$load("duC9l"),
    $705cb62515da7707$var$load("ci4aH"),
    $705cb62515da7707$var$load("l1nJ9"),
    $705cb62515da7707$var$load("eBRUf"),
    $705cb62515da7707$var$load("9Vh0G"),
    $705cb62515da7707$var$load("hBIgN"),
    $705cb62515da7707$var$load("h4Nf7"),
    $705cb62515da7707$var$load("7f9Fz"),
    $705cb62515da7707$var$load("8YSo7"),
    $705cb62515da7707$var$load("e7ZUf"),
    $705cb62515da7707$var$load("gL8bn"),
    $705cb62515da7707$var$load("g9CVe"),
    $705cb62515da7707$var$load("djHM5"),
    $705cb62515da7707$var$load("eJQji"),
    $705cb62515da7707$var$load("6wr18"),
    $705cb62515da7707$var$load("kjZZD"),
    $705cb62515da7707$var$load("3JSgG"),
    $705cb62515da7707$var$load("dRpV3"),
    $705cb62515da7707$var$load("ffEVr"),
    $705cb62515da7707$var$load("dTsOE"),
    $705cb62515da7707$var$load("jYUNl"),
    $705cb62515da7707$var$load("foy8I"),
    $705cb62515da7707$var$load("jY21r"),
    $705cb62515da7707$var$load("2vAWg"),
    $705cb62515da7707$var$load("7cABH"),
    $705cb62515da7707$var$load("9jjvO"),
    $705cb62515da7707$var$load("i8eeg"),
    $705cb62515da7707$var$load("iFdoJ"),
    $705cb62515da7707$var$load("2uVTT"),
    $705cb62515da7707$var$load("hhss7"),
    $705cb62515da7707$var$load("Wowvf"),
    $705cb62515da7707$var$load("4Nzvy"),
    $705cb62515da7707$var$load("hJpvQ"),
    $705cb62515da7707$var$load("bIPPg"),
    $705cb62515da7707$var$load("lnKog"),
    $705cb62515da7707$var$load("h3ABO"),
    $705cb62515da7707$var$load("kC80R"),
    $705cb62515da7707$var$load("7EorR"),
    $705cb62515da7707$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("fgLed", function(module, exports) {

let $b1dcfc32f0e1500b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b1dcfc32f0e1500b$var$load("2YffH"),
    $b1dcfc32f0e1500b$var$load("lqFMg"),
    $b1dcfc32f0e1500b$var$load("duC9l"),
    $b1dcfc32f0e1500b$var$load("ci4aH"),
    $b1dcfc32f0e1500b$var$load("l1nJ9"),
    $b1dcfc32f0e1500b$var$load("eBRUf"),
    $b1dcfc32f0e1500b$var$load("9Vh0G"),
    $b1dcfc32f0e1500b$var$load("hBIgN"),
    $b1dcfc32f0e1500b$var$load("h4Nf7"),
    $b1dcfc32f0e1500b$var$load("7f9Fz"),
    $b1dcfc32f0e1500b$var$load("8YSo7"),
    $b1dcfc32f0e1500b$var$load("e7ZUf"),
    $b1dcfc32f0e1500b$var$load("gL8bn"),
    $b1dcfc32f0e1500b$var$load("g9CVe"),
    $b1dcfc32f0e1500b$var$load("djHM5"),
    $b1dcfc32f0e1500b$var$load("eJQji"),
    $b1dcfc32f0e1500b$var$load("6wr18"),
    $b1dcfc32f0e1500b$var$load("kjZZD"),
    $b1dcfc32f0e1500b$var$load("3JSgG"),
    $b1dcfc32f0e1500b$var$load("dRpV3"),
    $b1dcfc32f0e1500b$var$load("ffEVr"),
    $b1dcfc32f0e1500b$var$load("dTsOE"),
    $b1dcfc32f0e1500b$var$load("jYUNl"),
    $b1dcfc32f0e1500b$var$load("foy8I"),
    $b1dcfc32f0e1500b$var$load("jY21r"),
    $b1dcfc32f0e1500b$var$load("2vAWg"),
    $b1dcfc32f0e1500b$var$load("7cABH"),
    $b1dcfc32f0e1500b$var$load("9jjvO"),
    $b1dcfc32f0e1500b$var$load("i8eeg"),
    $b1dcfc32f0e1500b$var$load("iFdoJ"),
    $b1dcfc32f0e1500b$var$load("2uVTT"),
    $b1dcfc32f0e1500b$var$load("hhss7"),
    $b1dcfc32f0e1500b$var$load("Wowvf"),
    $b1dcfc32f0e1500b$var$load("4Nzvy"),
    $b1dcfc32f0e1500b$var$load("hJpvQ"),
    $b1dcfc32f0e1500b$var$load("bIPPg"),
    $b1dcfc32f0e1500b$var$load("lnKog"),
    $b1dcfc32f0e1500b$var$load("h3ABO"),
    $b1dcfc32f0e1500b$var$load("kC80R"),
    $b1dcfc32f0e1500b$var$load("7EorR"),
    $b1dcfc32f0e1500b$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("jqQCa", function(module, exports) {

let $e259423242c2f932$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e259423242c2f932$var$load("e7ZUf"),
    $e259423242c2f932$var$load("gL8bn"),
    $e259423242c2f932$var$load("2YffH"),
    $e259423242c2f932$var$load("lqFMg"),
    $e259423242c2f932$var$load("duC9l"),
    $e259423242c2f932$var$load("ci4aH"),
    $e259423242c2f932$var$load("hJpvQ"),
    $e259423242c2f932$var$load("l1nJ9"),
    $e259423242c2f932$var$load("eBRUf"),
    $e259423242c2f932$var$load("9Vh0G"),
    $e259423242c2f932$var$load("hBIgN"),
    $e259423242c2f932$var$load("h4Nf7"),
    $e259423242c2f932$var$load("7f9Fz"),
    $e259423242c2f932$var$load("8YSo7"),
    $e259423242c2f932$var$load("g9CVe"),
    $e259423242c2f932$var$load("djHM5"),
    $e259423242c2f932$var$load("eJQji"),
    $e259423242c2f932$var$load("6wr18"),
    $e259423242c2f932$var$load("kjZZD"),
    $e259423242c2f932$var$load("3JSgG"),
    $e259423242c2f932$var$load("dRpV3"),
    $e259423242c2f932$var$load("ffEVr"),
    $e259423242c2f932$var$load("dTsOE"),
    $e259423242c2f932$var$load("jYUNl"),
    $e259423242c2f932$var$load("foy8I"),
    $e259423242c2f932$var$load("jY21r"),
    $e259423242c2f932$var$load("2vAWg"),
    $e259423242c2f932$var$load("7cABH"),
    $e259423242c2f932$var$load("9jjvO"),
    $e259423242c2f932$var$load("i8eeg"),
    $e259423242c2f932$var$load("iFdoJ"),
    $e259423242c2f932$var$load("bIPPg"),
    $e259423242c2f932$var$load("2uVTT"),
    $e259423242c2f932$var$load("hhss7"),
    $e259423242c2f932$var$load("Wowvf"),
    $e259423242c2f932$var$load("4Nzvy"),
    $e259423242c2f932$var$load("h3ABO"),
    $e259423242c2f932$var$load("kC80R"),
    $e259423242c2f932$var$load("7EorR"),
    $e259423242c2f932$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("eJ3ji", function(module, exports) {

let $ab87d604caeccd85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ab87d604caeccd85$var$load("e7ZUf"),
    $ab87d604caeccd85$var$load("gL8bn"),
    $ab87d604caeccd85$var$load("2YffH"),
    $ab87d604caeccd85$var$load("lqFMg"),
    $ab87d604caeccd85$var$load("duC9l"),
    $ab87d604caeccd85$var$load("ci4aH"),
    $ab87d604caeccd85$var$load("l1nJ9"),
    $ab87d604caeccd85$var$load("eBRUf"),
    $ab87d604caeccd85$var$load("9Vh0G"),
    $ab87d604caeccd85$var$load("hBIgN"),
    $ab87d604caeccd85$var$load("h4Nf7"),
    $ab87d604caeccd85$var$load("7f9Fz"),
    $ab87d604caeccd85$var$load("8YSo7"),
    $ab87d604caeccd85$var$load("g9CVe"),
    $ab87d604caeccd85$var$load("djHM5"),
    $ab87d604caeccd85$var$load("eJQji"),
    $ab87d604caeccd85$var$load("6wr18"),
    $ab87d604caeccd85$var$load("kjZZD"),
    $ab87d604caeccd85$var$load("3JSgG"),
    $ab87d604caeccd85$var$load("dRpV3"),
    $ab87d604caeccd85$var$load("ffEVr"),
    $ab87d604caeccd85$var$load("dTsOE"),
    $ab87d604caeccd85$var$load("jYUNl"),
    $ab87d604caeccd85$var$load("foy8I"),
    $ab87d604caeccd85$var$load("jY21r"),
    $ab87d604caeccd85$var$load("2vAWg"),
    $ab87d604caeccd85$var$load("7cABH"),
    $ab87d604caeccd85$var$load("9jjvO"),
    $ab87d604caeccd85$var$load("i8eeg"),
    $ab87d604caeccd85$var$load("iFdoJ"),
    $ab87d604caeccd85$var$load("2uVTT"),
    $ab87d604caeccd85$var$load("hhss7"),
    $ab87d604caeccd85$var$load("Wowvf"),
    $ab87d604caeccd85$var$load("4Nzvy"),
    $ab87d604caeccd85$var$load("hJpvQ"),
    $ab87d604caeccd85$var$load("bIPPg"),
    $ab87d604caeccd85$var$load("lnKog"),
    $ab87d604caeccd85$var$load("h3ABO"),
    $ab87d604caeccd85$var$load("kC80R"),
    $ab87d604caeccd85$var$load("7EorR"),
    $ab87d604caeccd85$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("4293o", function(module, exports) {

let $2efe5f36992590c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2efe5f36992590c2$var$load("e7ZUf"),
    $2efe5f36992590c2$var$load("gL8bn"),
    $2efe5f36992590c2$var$load("2YffH"),
    $2efe5f36992590c2$var$load("lqFMg"),
    $2efe5f36992590c2$var$load("duC9l"),
    $2efe5f36992590c2$var$load("ci4aH"),
    $2efe5f36992590c2$var$load("l1nJ9"),
    $2efe5f36992590c2$var$load("eBRUf"),
    $2efe5f36992590c2$var$load("9Vh0G"),
    $2efe5f36992590c2$var$load("hBIgN"),
    $2efe5f36992590c2$var$load("h4Nf7"),
    $2efe5f36992590c2$var$load("7f9Fz"),
    $2efe5f36992590c2$var$load("8YSo7"),
    $2efe5f36992590c2$var$load("g9CVe"),
    $2efe5f36992590c2$var$load("djHM5"),
    $2efe5f36992590c2$var$load("eJQji"),
    $2efe5f36992590c2$var$load("6wr18"),
    $2efe5f36992590c2$var$load("kjZZD"),
    $2efe5f36992590c2$var$load("3JSgG"),
    $2efe5f36992590c2$var$load("dRpV3"),
    $2efe5f36992590c2$var$load("ffEVr"),
    $2efe5f36992590c2$var$load("dTsOE"),
    $2efe5f36992590c2$var$load("jYUNl"),
    $2efe5f36992590c2$var$load("foy8I"),
    $2efe5f36992590c2$var$load("jY21r"),
    $2efe5f36992590c2$var$load("2vAWg"),
    $2efe5f36992590c2$var$load("7cABH"),
    $2efe5f36992590c2$var$load("9jjvO"),
    $2efe5f36992590c2$var$load("i8eeg"),
    $2efe5f36992590c2$var$load("iFdoJ"),
    $2efe5f36992590c2$var$load("2uVTT"),
    $2efe5f36992590c2$var$load("hhss7"),
    $2efe5f36992590c2$var$load("Wowvf"),
    $2efe5f36992590c2$var$load("4Nzvy"),
    $2efe5f36992590c2$var$load("hJpvQ"),
    $2efe5f36992590c2$var$load("bIPPg"),
    $2efe5f36992590c2$var$load("lnKog"),
    $2efe5f36992590c2$var$load("h3ABO"),
    $2efe5f36992590c2$var$load("kC80R"),
    $2efe5f36992590c2$var$load("7EorR"),
    $2efe5f36992590c2$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $h82at.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $1cfRh.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.a94df528.js.map
